import { render } from "./App.vue?vue&type=template&id=1a428a90"
const script = {}

import "./App.vue?vue&type=style&index=0&id=1a428a90&lang=css"

import exportComponent from "/Users/guodi/works/vue/hzcjz/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__